import { IEmployeeRole } from "@/entity/shared/referential";

export function getEmployeCost(employeRole: IEmployeeRole,projectEntityLabel: string) {
    if(projectEntityLabel =='FRA'){
        return employeRole.rate ?? 0;
    }
    else if(projectEntityLabel == 'CAN') {
        return employeRole.rateCanada ?? 0
    }
    return 0;
}